export const ITEMS_PER_PAGE = 30
export const EXPENSES_COLORS = ['#FF8700', '#6C5BEF', '#0A7AFF', '#849223', '#75DBCD', '#A22522', '#01295F', '#3E5641']
